import { useCreateUserFeedbackMutation } from "@api/feedback";
import { useToastEffect } from "@hooks/hooks";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useModal } from "./index";

export function useFeedbackModal() {
  const { Modal, openModal } = useModal();

  const { t } = useTranslation("feedback");

  const FeedbackModalComponent = useMemo(
    () =>
      function FeedbackModalInner() {
        const [inputValue, setInputValue] = useState("");

        const [createUserFeedback, { isError, isSuccess, error }] =
          useCreateUserFeedbackMutation();

        useToastEffect({
          isError,
          isSuccess,
          error,
          successMessage: t("form.feedbackSent"),
        });

        const handleConfirm = () => {
          createUserFeedback({ message: inputValue });
          setInputValue("");
        };

        return (
          <Modal
            title={t("feedback")}
            onConfirmLabel={t("form.sendFeedback")}
            onConfirm={handleConfirm}
            onCancel={() => {}}
          >
            <span>{t("form.feedbackInfo")}</span>

            <textarea
              value={inputValue}
              placeholder={t("form.feedbackPlaceholder")}
              className="mt-sm h-52 w-full resize-none rounded-lg border-2 bg-neutral p-2 focus:outline-none"
              onChange={(event) => setInputValue(event.target.value)}
            />
          </Modal>
        );
      },
    [Modal, t],
  );

  return {
    FeedbackModal: FeedbackModalComponent,
    openFeedbackModal: openModal,
  };
}
